import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling40BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-40');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling40BPM;